import React, { useCallback, useRef, useEffect } from "react";
import Countdown from "react-countdown";


export default function ExamTimer(props) {
  // Destructure necessary props
  const { examDetail, isVideoInterviewTest, isRecordingDone, isVideoUploading, setTimeoutModelShow, setTimeoutModelOneMinuteShow, setIsTimeUp, isWindowSwitched, isPhotoMatchingInProgress, isPhotoServerPaused, isFullscreenExited } =
    props;

  // Calculate total exam time in milliseconds. Never fabricate a small number here - a
  // `1` makes the countdown complete almost immediately, firing the actual "Time's up!"
  // UI and setIsTimeUp(true) on render. Full allotted duration instead, same as
  // everywhere else this fallback was fixed this session.
  const timeRemaining = examDetail[0].time_remaining;
  const isValidTimeRemaining = timeRemaining !== null && timeRemaining !== undefined && timeRemaining !== "" && !isNaN(Number(timeRemaining)) && Number(timeRemaining) > 0;
  const fallbackTimeRemaining = examDetail[0].total_test_time || (examDetail[0].instanceduration * 60);
  const effectiveTimeRemaining = isValidTimeRemaining ? Number(timeRemaining) : fallbackTimeRemaining;

  const [targetDate] = React.useState(() => Date.now() + effectiveTimeRemaining * 1000);
  const countdownRef = useRef(null);

  const totalExamTime = effectiveTimeRemaining * 1000;

  // Actually pause/resume the countdown during upload — keeps remaining time accurate
  useEffect(() => {
    if (!countdownRef.current) return;
    if (isVideoUploading || isWindowSwitched || isPhotoMatchingInProgress || isPhotoServerPaused || isFullscreenExited) {
      countdownRef.current.pause();
    } else {
      countdownRef.current.start();
    }
  }, [isVideoUploading, isWindowSwitched, isPhotoMatchingInProgress, isPhotoServerPaused, isFullscreenExited]);

  // Update examDetail if time_remaining was invalid
  if (!isValidTimeRemaining) {
    examDetail[0].time_remaining = fallbackTimeRemaining;
    console.log("Investigate: time_remaining null in Timer.jsx - TIMER INIT, falling back to full allotted duration:", fallbackTimeRemaining);
  }

  // Safe localStorage update
  const updateLocalStorageTime = useCallback((timeInSeconds) => {
    try {
      localStorage.setItem("remainingTime", timeInSeconds.toString());
    } catch (error) {
      console.warn("Local storage update failed", error);
    }
  }, []);

  // Renderer function for custom countdown display
  const renderer = ({ hours, minutes, seconds, total, completed }) => {
    // Formatting to ensure two-digit display

    // Convert total milliseconds back to seconds
    const currentRemainingTime = Math.floor(total / 1000);

    examDetail[0].time_remaining = currentRemainingTime;

    // localStorage.setItem("remainingTime", Math.floor(total / 1000));
    updateLocalStorageTime(currentRemainingTime);

    const formatTime = (time) => time.toString().padStart(2, "0");

    if (completed) {
      // Exam time is up
      return (
        <>
          <span>Time's up!</span>
          {setTimeoutModelShow(true)}
          {setTimeoutModelOneMinuteShow(true)}
          {setIsTimeUp(true)}
        </>
      );
    } else {
      // Check for one-minute warning
      if (hours === 0 && minutes === 1 && seconds === 0) {
        setTimeoutModelOneMinuteShow(true);
      }

      return (
        <span style={isVideoUploading || isPhotoServerPaused || isFullscreenExited ? { opacity: 0.5 } : {}}>
          {isVideoUploading || isPhotoServerPaused || isFullscreenExited ? "⏸ " : ""}{formatTime(hours)} : {formatTime(minutes)} : {formatTime(seconds)}
        </span>
      );
    }
  };

  return (
    <Countdown
      ref={countdownRef}
      date={targetDate}
      renderer={renderer}
      autoStart={true}
      controlled={false}
      onComplete={() => {
        if (isVideoInterviewTest && isRecordingDone) {
          setTimeoutModelShow(true);
          setTimeoutModelOneMinuteShow(true);
          setIsTimeUp(true);
        }
      }}
    />
  );
}
